import { getRegExp } from 'korean-regexp';

function getOptionRoleElement(element, options = { all: true }) {
  return options.all ? element?.querySelectorAll('[role="option"]') : element?.querySelector('[role="option"]');
}
function isMatchedItem(valueParams, searchKeyword) {
  const { textValue, value } = valueParams;
  return getRegExp(searchKeyword, {
    ignoreSpace: true
  }).test(textValue ?? value);
}

export { getOptionRoleElement, isMatchedItem };
//# sourceMappingURL=item.mjs.map
